export type CTE_DEVICES = {
  MOBILE: string,
  PC: string,
  TABLET: string,
}

export const DEVICES:CTE_DEVICES = {
  MOBILE: 'mobile',
  PC: 'pc',
  TABLET: 'tablet',
}

export type ENVIRONMENT_TYPE = {
  QA: string,
  DEV: string,
  PROD: string,
}

export const ENVIRONMENTS = {
  QA: 'qa',
  DEV: 'dev',
  PROD: 'prod',
}

export type NETWORK_STATUS_TYPE = {
  FETCHING: string,
  SUCCESS: string,
  ERROR: string,
}

export const NETWORK_STATUS = {
  FETCHING: 'fetching',
  SUCCESS: 'success',
  ERROR: 'error',
}
